// Library Imports
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

// Local Import
import Popover from '../Popover';
import { MenuHeader, MenuList } from './menuList';

const Header = () => {
  const params = useLocation();
  const [isMenuList, setIsMenutList] = useState<any>(false)
  const pageName = params?.pathname?.split('/')[1];

  const getPageName = (path: string) => {
    let pageName = '';
    const routeName = path?.includes('-') ? path?.split('-') : path;
    if (typeof routeName === 'object') {
      pageName = routeName
        ?.map((item) => item?.charAt(0)?.toLocaleUpperCase() + item?.slice(1))
        ?.join(' ');
    } else {
      pageName =
        routeName?.charAt(0)?.toLocaleUpperCase() + routeName?.slice(1);
    }
    return pageName;
  };

  return (
    <React.Fragment>
      <div className='py-[13px] pl-4 pr-[17px] flex items-center bg-goose-white justify-between  border-cool-grey-200'>
        <div>
          <h1 className='text-[14px] font-[550] leading-[22px] text-foreground-primary'>
            {pageName ? getPageName(pageName) : 'Dashboard'}
          </h1>
        </div>

        <div className='flex gap-1 justify-center items-center cursor-pointer' onClick={() => {
          setIsMenutList(!isMenuList)
        }}>
          <Popover
            dropdownOpen={isMenuList}
            setDropdownOpen={setIsMenutList}
            menuHeading={<MenuHeader />}
          >
            <MenuList />
          </Popover>
        </div>
      </div>
    </React.Fragment >
  );
};

export default Header;
